import { ChildrenType } from "seneca-common/features/parents/features/parent/service/hooks/types";
import { truncateText } from "seneca-common/utils/functions/formatting/truncateText";

const CHILD_NAME_CHARACTER_LIMIT_DEFAULT = 25;
const CHILD_NAME_CHARACTER_LIMIT_MOBILE = 12;

export function getChildNameLimitOnDevice(isMobile: boolean) {
  return isMobile
    ? CHILD_NAME_CHARACTER_LIMIT_MOBILE
    : CHILD_NAME_CHARACTER_LIMIT_DEFAULT;
}

export function getChildName({
  child,
  shouldTruncate = true,
  limit = CHILD_NAME_CHARACTER_LIMIT_DEFAULT,
  shouldDisplayFullName = false
}: {
  child: ChildrenType | undefined;
  shouldTruncate?: boolean;
  limit?: number;
  shouldDisplayFullName?: boolean;
}) {
  if (!child) return "";

  if (child.givenName) {
    if (shouldDisplayFullName && child.familyName)
      return `${child.givenName} ${child.familyName}`;
    else return child.givenName;
  }

  return truncateText({
    text: child.email,
    shouldTruncateOnDevice: shouldTruncate,
    limit
  });
}
